import { render } from "./InputDate.vue?vue&type=template&id=782bc9fc"
import script from "./InputDate.vue?vue&type=script&lang=js"
export * from "./InputDate.vue?vue&type=script&lang=js"

import "./InputDate.vue?vue&type=style&index=0&id=782bc9fc&lang=scss"
script.render = render

export default script